
import cloneDeep from 'lodash/cloneDeep'
import { pushInHistory, addingNewStates } from '../History/stateHistory'

export default (store) => {
    store.subscribe(function (mutation, state) {
      if (_isLoggableMutations(mutation)) {
        let tags = cloneDeep(state.video.tags);
        let selection = cloneDeep(state.selection);

        addingNewStates();

        pushInHistory({tags: tags, selection: selection});
      }
    })
};

function _isLoggableMutations(mutation) {
  const mutationsTypeToLog = [
    'setPlayer',
    'addTag',
    'deleteTag',
    'copyTag',
    'addScene',
    'deleteScene',
    'updateMetadata',
    'deleteWaypoint',
    'commitWaypoint',
    'copyWaypoint',
    'addTrackedWaypoints',
    'removeTrackedWaypoints',
    'promoteTrackedWaypoints',
    'updateQuiz',
    'updateSingleChoice',
    'updateEmbed'
  ];
  return mutationsTypeToLog.filter(mutationTypeToLog => (mutationTypeToLog === mutation.type)).length > 0;
}